import { privateRequest, type ApiResponse } from "../axios";

const ENDPOINTS = {
    GET_ALL_REPORTS: "api/ExportReportSettings/GetAllReports",
    GET_EXPORT_REPOT_SETTING: "api/ExportReportSettings/GetExportReportSetting",
    ADD_UPDATE_EXPORT_REPORT_SETTING: "api/ExportReportSettings/AddOrUpdateExportReportSetting",
    GET_NOTIFICATION_USERS: "api/ExportReportSettings/GetNotificationUsers",
    ADD_UPDATE_NOTIFICATION_USERS: "api/ExportReportSettings/AddOrUpdateNotificationUsers",
}

const getAllExportReports = async (): Promise<ApiResponse<any[]>> => {
    const res = await privateRequest.get<ApiResponse<any[]>>(ENDPOINTS.GET_ALL_REPORTS);
    return res.data;
};

const getExportReportSetting = async (): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.GET_EXPORT_REPOT_SETTING);
    return res.data;
};

const addOrUpdateExportReportSetting = async (payload: any[]): Promise<ApiResponse<any>> => {
    const res = await privateRequest.post<ApiResponse<any>>(ENDPOINTS.ADD_UPDATE_EXPORT_REPORT_SETTING, payload);
    return res.data;
};

const getNotificationUsers = async (): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.GET_NOTIFICATION_USERS);
    return res.data;
};

const addOrUpdateNotificationUsers = async (payload: any[]): Promise<ApiResponse<any>> => {
    const res = await privateRequest.post<ApiResponse<any>>(ENDPOINTS.ADD_UPDATE_NOTIFICATION_USERS, payload);
    return res.data;
};

const ExportReportSettings = {
    getAllExportReports,
    getExportReportSetting,
    addOrUpdateExportReportSetting,
    getNotificationUsers,
    addOrUpdateNotificationUsers,
};

export default ExportReportSettings;